export default __webpack_public_path__ + "static/media/BeltVelocityImg.52732049.png";